import { Avatar as AvatarPrimitive } from 'radix-ui';
import { cn } from '../../lib/cn';

export interface AvatarProps {
  /** Pflicht: ergibt Initialen und Tooltip. */
  name: string;
  /** Foto, z. B. aus Google Workspace. */
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const groesse = {
  sm: 'size-[22px] text-[10px]',
  md: 'size-7 text-[11px]',
  lg: 'size-10 text-sm',
};

/** Eine Person als Foto oder Initialen. Bei Firmen kein Avatar, sondern der Name. */
export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const initialen = name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return (
    <AvatarPrimitive.Root
      title={name}
      aria-label={name}
      role="img"
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-highlight-soft font-semibold leading-none tracking-[.02em] text-highlight',
        groesse[size],
        className,
      )}
    >
      {src && <AvatarPrimitive.Image src={src} alt="" className="size-full object-cover" />}
      <AvatarPrimitive.Fallback delayMs={src ? 300 : 0}>{initialen}</AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
